module.exports = __webpack_public_path__ + "img/2_ava.509217dd.jpg";